import {helpers} from 'vuelidate/lib/validators'

// validator for (decimal) percentage values between 0 and 100
export const percentage =
  helpers.regex ('percentage', /^0*(?:100(?:\.0+)|[0-9]{1,2}(?:\.[0-9]*)?)$/)
